import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerUhcIcon = lazy(() => import('./svg-components/eiv-payer-uhc-icon'));

const EivPayerUhcIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerUhcIcon {...rest} />
  </Suspense>
);

export default EivPayerUhcIcon;
